const { mergeFilterObjects } = require('../../location/tools/filters')
const { getUserShipmentFilters } = require('./get-shipment-filters')
const get = require('lodash/get')

/**
 *
 * @param {Object} params - The parameters object
 * @param {Object} params.filters - The filters to apply
 * @param {boolean} [params.applyUserFilters=false] - Whether to apply user filters
 * @param {Object} params.user - The user object containing information such as funders, routes, programs, and roles
 * @returns {Object} - The merged filters or the original filters if applyUserFilters is false
 */
function applyLMDUserFilters ({ filters, applyUserFilters = false, user }) {
  if (applyUserFilters && user) {
    const defaultShipmentFilters = getUserShipmentFilters(user)
    const cleanedDefaults = { ...defaultShipmentFilters }

    /**
     * Edge case: UI filtering by program_id for user with multiple programs
     * When a user has access to multiple programs (e.g. nhlmis user), and selects a specific program in the UI filter,
     * mergeFilterObjects would normally concatenate the UI selection with the user's allowed programs.
     */
    if (filters.program_id && defaultShipmentFilters.program_id) {
      const allowedPrograms = [].concat(defaultShipmentFilters.program_id)
      const selectedProgram = filters.program_id
      if (allowedPrograms.includes(selectedProgram)) {
        delete cleanedDefaults.program_id
      } else {
        // If user-provided program is not in their allowed programs, disregard filter and fallback to user's default programs
        delete filters.program_id
      }
    }
    // if the user is a carrier
    if (get(user, 'roles', []).some(role => role.includes('userRole:psm-carrier'))) {
      filters.carrier_id = user.organisationId
    }
    return mergeFilterObjects(filters, cleanedDefaults)
  }
  return filters
}

module.exports = {
  applyLMDUserFilters
}
